import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useConfig } from 'app/hooks';
import { Container } from 'app/components';
import { LegalInfoListItem } from './styles';
import { SectionInfo, SectionInfoTitle, SectionInfoContent } from '../styles';

const propTypes = {
  legalInfo: PropTypes.arrayOf(PropTypes.object).isRequired
};

const LegalInformation = ({ legalInfo }) => {
  const [t] = useTranslation();
  const {
    media: { docsPrefix }
  } = useConfig();

  return (
    <SectionInfo>
      <Container>
        <SectionInfoTitle>{t('info.legal_title')}</SectionInfoTitle>
        <SectionInfoContent>
          {legalInfo.length ? (
            <Fragment>
              <ul>
                {legalInfo.map(info => (
                  <LegalInfoListItem key={info.doc}>
                    <a
                      className="l-legal-info__link"
                      href={info.doc.endsWith('.pdf') ? docsPrefix(info.doc) : info.doc}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {info.label}
                    </a>
                  </LegalInfoListItem>
                ))}
              </ul>
            </Fragment>
          ) : (
            <p>{t('info.no_info')}</p>
          )}
        </SectionInfoContent>
      </Container>
    </SectionInfo>
  );
};

LegalInformation.propTypes = propTypes;
export default LegalInformation;
